export default "/packs/images/woman-in-wheelchair-listening-music-with-headphones~26ada1b5bb8ea75320b359598bf1773b.jpeg";